import styled from 'styled-components';

const FormGroup = styled.div`
  display: grid;
  grid-gap: 4px;
  width: 100%;
`;

export default FormGroup;
